import React from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

import "./index.css";

export function CheckboxList(props) {
  const { items, onChange } = props;
  return (
    <>
      <h3 style={{ margin: "10px 0 0", padding: "10px 0 0" }}>Physicians</h3>
      <FormGroup className="checkbox-list">
        {items.map((item, i) => {
          return (
            <FormControlLabel
              key={i}
              className="checkbox-item"
              control={
                <Checkbox
                  id={item.id}
                  checked={item.selected}
                  name="checkedB"
                  color="primary"
                  onChange={onChange}
                />
              }
              label={item.name}
            />
          );
        })}
      </FormGroup>
    </>
  );
}
